import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export const TOKEN_KEY = 'token';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public set(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public get(key: string): string | null {
    return localStorage.getItem(key);
  }

  public delete(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): Observable<boolean> {
    return new Observable((subscriber) => {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.clear();
      subscriber.next(true);
    });
  }
}
